export enum ChargeType {
  CREATE = 'CREATE',
  RENEWAL = 'RENEWAL',
  YEARLY = 'YEARLY'
}
